<template>
   <div>
      <atom-title
         title="Reset password"
         :color="formSubmitted ? 'success' : 'secondary'"
      />
      <form v-if="!formSubmitted" @submit.prevent="handleSubmit">
         <error-list
            :errors="errors.non_field"
         />
         <input-field
            label="New Password"
            placeholder="Enter your new password"
            type="password"
            v-model="fields.password"
            :errors="errors.password"
            required
         />
         <input-field
            label="Confirm password"
            placeholder="Re-enter password"
            type="password"
            v-model="fields.confirm_password"
            :errors="errors.confirm_password"
            required
         />
         <submit-btn
            :isLoading="isSubmitting"
            label="Set new password"
            loadingLabel="Setting new password"
         />
      </form>
      <success-msg
         :isSuccess="formSubmitted"
         text="The password has been successfully reset. You can now
            log in to MEP using the new credentials."
      />
</div>
</template>

<script>
import AtomTitle from '../../../atoms/Login/Title';
import ErrorList from '../../../molecules/Login/Errors';
import InputField from '../../../molecules/Login/InputField';
import SubmitBtn from '../../../molecules/Login/SubmitBtn';
import SuccessMsg from '../../../molecules/Register/SuccessMsg';

import { mapActions } from 'vuex';

export default {
   name: 'PasswordResetForm',
   components: {
      AtomTitle,
      InputField,
      SubmitBtn,
      ErrorList,
      SuccessMsg,
   },
   data()
   {
      return {
         fields: {
            password: '',
            confirm_password: '',
         },
         errors: {
            password: [],
            confirm_password: [],
            non_field: []
         },
         formSubmitted: false,
         isSubmitting: false,
      };
   },
   methods: {
      ...mapActions('users', ['setNewPassword']),
      setErrors({password, confirm_password, non_field})
      {
         this.errors.non_field = non_field ? non_field : [];
         this.errors.password = password ? password : [];
         this.errors.confirm_password = confirm_password ? confirm_password : [];
      },
      async handleSubmit()
      {
         if (this.isSubmitting) return;
         this.isSubmitting = true;
         this.setErrors({});
         if (this.fields.password !== this.fields.confirm_password)
         {
            this.errors.password.push("Passwords must match");
            this.errors.confirm_password.push("Passwords must match");
            this.isSubmitting = false;
            return;
         }
         try
         {
            await this.setNewPassword({
               password: this.fields.password,
               token: this.$route.params.token,
            })
            this.formSubmitted = true;
         }
         catch (error)
         {
            const response = error.response;
            if (!response)
            {
               this.errors.non_field = ["Couldn't connect to server. (Please check internet connection)"];
            }
            else if (response.status===404)
            {
               this.errors.non_field = ["User not found. Are you using a valid link to reset password?"];
            }
            else if (response.status===400)
            {
               const { password } = response.data;
               this.errors.password = password ? password : [];
            }
            else
            {
               this.errors.non_field = [error.message];
            }
         }
         this.isSubmitting = false;
      }
   }
}
</script>

<style>

</style>